module.exports = __webpack_public_path__ + "static/media/gluehhealth.2c2fab51.jpg";